"use client"

import { useState, useEffect } from "react"
import "./home-client-v2.css"
import API from "../services/api"

const SERVER_BASE = "https://api.ibistunis.com"
const getMediaUrl = (url) => {
  if (!url) return null
  if (url.startsWith("blob:") || url.startsWith("http")) return url
  return `${SERVER_BASE}${url.startsWith("/") ? "" : "/"}${url}`
}

const MEMBERSHIP_BANNER_IMAGE_URL = "/images/member.png"

const ECOGESTE_CARD_BG_IMAGE_URL = "/images/ecogest.png"

// Translation system
const translations = {
  fr: {
    // Hero section
    welcome: "Bienvenue à IBIS Tunis",
    scrollDown: "DÉFILER VERS LE BAS",
    getIntoTheGroove: "Entrez dans le rythme",
    foodOffers: "Offres restauration",
    roomDirectory: "Livret d'accueil",
    ourHotelCrushes: "Notre hôtel et nos coups de cœur",
    contactCard: "Contact",
    toSaveEnvironment: "Nos écogestes",
    additionalServicesCard: "Donnez votre avis",
    livretaccueil: "A propos de l'hôtel",
    // Main banners
    coffeeCup: "UNE TASSE DE CAFÉ",
    forYourReview: "POUR VOTRE AVIS",
    clickImageReview: "Cliquez sur l'image et laissez votre avis",
    discoverOur: "DÉCOUVREZ NOS",
    restaurants: "Rrestaurant",
    exploreSpecialties: "Explorez nos spécialités culinaires et notre gastronomie",
    relaxAt: "DÉTENDEZ-VOUS À",
    ourSkyLounge: "NOTRE SKY LOUNGE",
    panoramicView: "Profitez d'une vue panoramique avec des boissons premium",

    // Feature cards
    ibismusic: "Ibis Music",
    boissonsetnourritures: "Restaurant & Bar",
    serviceadditional: "S'informer",
    nosplaylist: "Nos playlists",
    plandesfax: "Se déplacer / Accès",
    presse: "Presse",
    encas: "ENCAS",
    bar: "Bar",
    petitdejeuner: "Petit-déjeuner",
    travailler: "Travailler",
    seminaire: "Business",
    lesecogestes: "Politique de développement durable et écogestes",
    avisgoogle: "Avis Google",
    facebookInstagram: "Facebook & Instagram",
    gardonsContact: "Gardons contact",
    seRestaurer: "Se restaurer",

    eat: "Restaurant Ibis",
    drink: "Bar",
    relax: "Sky Lounge",
    wellness: "in BALANCE BY IBIS",
    events: "Événements",
    services: "Services",
    roomService: "Restauration en chambre",
    business: "Meeting AT Ibis",
    feedback: "Avis",

    environmentalPolicy: "Politique environnementale",
    sustainablePractices: "Pratiques durables pour un avenir meilleur",

    // Navigation
    home: "Accueil",
    bar: "Bar",
    spa: "Spa",

    // Popup
    specialOffers: "Offres Spéciales Ibis",
    discoverPromotions:
      "Découvrez nos promotions exclusives et profitez de réductions exceptionnelles sur votre séjour. Réservez maintenant et économisez jusqu'à 30% !",
    discoverOffers: "Découvrir les offres",

    // Footer
    allRightsReserved: "Tous droits réservés",
    createdBy: "Créé par",
    giveUsFeedback: "Donnez nous votre avis",
    skipCleans: "Skip the clean",
    ecogeste: "Ecogeste",
    menu: "Menu",
    close: "Fermer",
    language: "Langue",
    membership: "Devenez membre",
    vibrezAvecNous: "Vibrez avec nous",
  },

  en: {
    // Hero section
    welcome: "Welcome to IBIS Tunis",
    scrollDown: "SCROLL DOWN",
    getIntoTheGroove: "Get into the groove",
    foodOffers: "Food offers",
    roomDirectory: "Welcome booklet",
    ourHotelCrushes: "Our hotel and crushes",
    contactCard: "Contact",
    toSaveEnvironment: "To save our environment",
    additionalServicesCard: "Give your review",

    // Main banners
    coffeeCup: "A CUP OF COFFEE",
    forYourReview: "FOR YOUR REVIEW",
    clickImageReview: "Click on the image and leave your review",
    discoverOur: "DISCOVER OUR",
    restaurants: "Rrestaurant",
    exploreSpecialties: "Explore our culinary specialties and gastronomy",
    relaxAt: "RELAX AT",
    ourSkyLounge: "OUR SKY LOUNGE",
    panoramicView: "Enjoy panoramic views with premium drinks",

    // Feature cards
    serviceadditional: "GET INFORMED",
    nosplaylist: "OUR PLAYLISTS",
    plandesfax: "Move around",
    presse: "Press",

    encas: "SNACKS",
    bar: "Bar",
    petitdejeuner: "BREAKFAST",
    travailler: "Work",
    seminaire: "Business",
    lesecogestes: "Sustainable development policy and ecogeste",

    giveUsFeedback: "Give us your feedback",
    skipCleans: "Skip the clean",

    eat: "Ibis  Restaurant",
    ibismusic: "Ibis Music",
    boissonsetnourritures: "Food and Drinks",

    livretaccueil: "About the hotel",
    avisgoogle: "Google Reviews",
    facebookInstagram: "Facebook & Instagram",
    gardonsContact: "Let's stay in touch",
    seRestaurer: "Dining",

    drink: "Bar",
    relax: "Sky Lounge",
    wellness: "in BALANCE BY IBIS",
    events: "Events",
    services: "Services",
    roomService: "in-room catering",
    business: "Meeting AT Ibis",
    feedback: "Feedback",

    environmentalPolicy: "Environmental Policy",
    sustainablePractices: "Sustainable practices for a better future",

    // Navigation
    home: "Home",
    bar: "Bar",
    spa: "Spa",

    // Popup
    specialOffers: "Ibis Special Offers",
    discoverPromotions:
      "Discover our exclusive promotions and enjoy exceptional discounts on your stay. Book now and save up to 30%!",
    discoverOffers: "Discover Offers",

    // Footer
    allRightsReserved: "All rights reserved",
    createdBy: "Created by",
    ecogeste: "Ecogeste",
    menu: "Menu",
    close: "Close",
    language: "Language",
    membership: "Become a member",
    vibrezAvecNous: "Vibe with us",
  },

  ar: {
    // Hero section
    welcome: "مرحباً بكم في ايبيس تونس",
    scrollDown: "انتقل للأسفل",
    getIntoTheGroove: "انضم إلى الإيقاع",
    foodOffers: "عروض الطعام",
    roomDirectory: "دليل الغرفة",
    ourHotelCrushes: "فندقنا ومفضلاتنا",
    contactCard: "اتصل بنا",
    toSaveEnvironment: "لنحمي بيئتنا",
    additionalServicesCard: "أعطِ رأيك",
    giveUsFeedback: "أعطنا رأيك",
    skipCleans: "تخطي التنظيف",
    // Main banners
    coffeeCup: "فنجان قهوة",
    forYourReview: "لرأيكم",
    clickImageReview: "انقر على الصورة واترك رأيك",
    discoverOur: "اكتشف",
    restaurants: "مطاعمنا",
    exploreSpecialities: "استكشف تخصصاتنا الطهوية وفن الطبخ لدينا",
    relaxAt: "استرخ في",
    ourSkyLounge: "صالة السكاي لاونج",
    panoramicView: "استمتع بإطلالة بانورامية مع المشروبات المميزة",

    // Feature cards
    eat: "مطاعم ايبيس",
    ibismusic: "موسيقى إيبيس",
    boissonsetnourritures: "مشروبات وطعام",

    serviceadditional: "تعرّف أكثر",
    nosplaylist: "قوائم التشغيل الخاصة بنا",
    plandesfax: "التنقل",
    presse: "الصحافة",
    encas: "وجبات خفيفة",
    bar: "بار",
    petitdejeuner: "إفطار",
    travailler: "العمل",
    seminaire: "عمل",
    lesecogestes: "سياسة التنمية المستدامة",
    avisgoogle: "تقييمات جوجل",
    facebookInstagram: "فيسبوك وإنستغرام",
    gardonsContact: "للتواصل معنا",
    seRestaurer: "تناول الطعام",
    livretaccueil: "كتيب الترحيب",
    drink: "حانة",
    relax: "صالة سكاي",

    wellness: "منتجع",
    events: "فعاليات",
    services: "خدمات",
    roomService: "خدمة الغرف",
    business: "أعمال",
    feedback: "آراء",

    environmentalPolicy: "السياسة البيئية",
    sustainablePractices: "ممارسات مستدامة لمستقبل أفضل",

    // Navigation
    home: "الرئيسية",
    bar: "البار",
    spa: "السبا",

    // Popup
    specialOffers: "عروض ايبيس الخاصة",
    discoverPromotions: "اكتشف عروضنا الحصرية واستمتع بخصومات استثنائية على إقامتك. احجز الآن ووفر حتى 30%!",
    discoverOffers: "اكتشف العروض",

    // Footer
    allRightsReserved: "جميع الحقوق محفوظة",
    createdBy: "تم إنشاؤه بواسطة",
    ecogeste: "Ecogeste",
    menu: "القائمة",
    close: "إغلاق",
    language: "اللغة",
    membership: "انضم كعضو",
    vibrezAvecNous: "انبض معنا",
  },
}

const languages = [
  { code: "fr", name: "Français", flag: "/images/fr-flag-v2.png" },
  { code: "en", name: "English", flag: "/images/en-flag-v2.png" },
  { code: "ar", name: "العربية", flag: "/images/ar-flag-v2.png" },
]

const HomeClient = () => {
  const [showPopup, setShowPopup] = useState(false)
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    if (typeof window === "undefined") return "fr"
    const saved = (localStorage.getItem("IBIS-language") || "").trim().toLowerCase()
    if (saved && translations[saved]) return saved
    return "fr"
  })
  const [modalConfig, setModalConfig] = useState(null)
  const [hasActiveOffer, setHasActiveOffer] = useState(false)
  const [activeOffer, setActiveOffer] = useState(null)
  const [appMenuOpen, setAppMenuOpen] = useState(false)

  // Get translation function
  const t = (key) => translations[currentLanguage][key] || translations.fr[key] || key

  const fetchModalConfig = async () => {
    try {
      const response = await API.get("/special-offer-modal")
      setModalConfig(response.data.data || response.data)
    } catch (error) {
      console.error("Error fetching modal config:", error)
      setModalConfig(null)
    }
  }

  useEffect(() => {
    fetchModalConfig()

    // Check if there is at least one active offer for now
    const fetchActiveOffers = async () => {
      try {
        const res = await API.get("/offres")
        const now = new Date()
        const found = res.data?.find((offre) => {
          if (!offre.active) return false
          const end = offre.endDate ? new Date(offre.endDate) : null
          if (end && now > end) return false
          return true
        })
        if (found) {
          setActiveOffer(found)
          setHasActiveOffer(true)
        }
      } catch (error) {
        console.error("Error checking active offers:", error)
        setHasActiveOffer(false)
      }
    }

    fetchActiveOffers()

    // Load saved language from localStorage (synced with RestaurantsMenusClient and other pages)
    const raw = localStorage.getItem("IBIS-language")
    const savedLanguage = raw ? raw.trim().toLowerCase() : null
    if (savedLanguage && translations[savedLanguage]) {
      setCurrentLanguage(savedLanguage)
      document.documentElement.dir = savedLanguage === "ar" ? "rtl" : "ltr"
      document.documentElement.lang = savedLanguage
    }

    // Resync language when user returns to this tab (e.g. changed language in another tab)
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        const raw2 = localStorage.getItem("IBIS-language")
        const lang = raw2 ? raw2.trim().toLowerCase() : null
        if (lang && translations[lang]) {
          setCurrentLanguage(lang)
          document.documentElement.dir = lang === "ar" ? "rtl" : "ltr"
          document.documentElement.lang = lang
        }
      }
    }
    document.addEventListener("visibilitychange", handleVisibilityChange)

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [])

  useEffect(() => {
    if (!hasActiveOffer) return
    const delay = modalConfig?.delaySeconds > 0 ? modalConfig.delaySeconds * 1000 : 0
    const timer = setTimeout(() => setShowPopup(true), delay)
    return () => clearTimeout(timer)
  }, [hasActiveOffer, modalConfig])

  useEffect(() => {
    if (appMenuOpen) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = ""
    }
    return () => {
      document.body.style.overflow = ""
    }
  }, [appMenuOpen])

  useEffect(() => {
    if (!appMenuOpen) return
    const onKey = (e) => {
      if (e.key === "Escape") setAppMenuOpen(false)
    }
    window.addEventListener("keydown", onKey)
    return () => window.removeEventListener("keydown", onKey)
  }, [appMenuOpen])

  // Language change handler
  const changeLanguage = (langCode) => {
    setCurrentLanguage(langCode)
    localStorage.setItem("IBIS-language", langCode)

    // Update document direction for Arabic
    document.documentElement.dir = langCode === "ar" ? "rtl" : "ltr"
    document.documentElement.lang = langCode
  }

  const getAllFeatureCards = () => [
    {
      id: "food-offers",
      title: t("seRestaurer"),
      image: "/images/restarant.jpg",
      fallback: "/placeholder.svg?height=300&width=200&text=Food",
      path: "/RestaurantBarClient",
    },
    {
      id: "ibismusic",
      title: t("ibismusic"),
      image: "/images/ibismusic.jpg",
      fallback: "/placeholder.svg?height=300&width=200&text=Ibis%20Music",
       url: "https://open.spotify.com/user/chpit9s8x82hu2f09dinn96qw?si=S3rSD5obTR27rAm-jTixUw",
    },
    {
      id: "travailler",
      title: t("travailler"),
      image: "/images/work.png",
      fallback: "/placeholder.svg?height=300&width=200&text=Travailler",
      path: "/travailler-client",
    },
    {
      id: "room-directory",
      title: t("roomDirectory"),
      image: "/images/livret.jpg",
      fallback: "/placeholder.svg?height=300&width=200&text=Directory",
      path: "/livret-client",
    },
    {
      id: "serviceadditional",
      title: t("additionalServicesCard"),
      image: "/images/informations.webp",
      fallback: "/placeholder.svg?height=300&width=200&text=Services",
      url: "https://www.google.com/travel/search?q=ibis%20tunis&g2lb=4965990%2C72471280%2C72560029%2C72573224%2C72647020%2C72686036%2C72803964%2C72882230%2C72958624%2C73059275%2C73064764%2C121608705%2C121620231&hl=en-TN&gl=tn&ssta=1&ts=CAEaRwopEicyJTB4MTJmZDM0NjQ5Y2Y1ZDMwYjoweDQ0NWQxYWIyZWVjYzkwN2YSGhIUCgcI6g8QBhgOEgcI6g8QBhgPGAEyAhAA&qs=CAEyE0Nnb0lfNkN5OXE3V3hxNUVFQUU4AkIJCX-QzO6yGl1EQgkJf5DM7rIaXUQ&ap=ugEHcmV2aWV3cw&ictx=111&ved=0CAAQ5JsGahcKEwjQkN2JgKCUAxUAAAAAHQAAAAAQBQ",
    },
   
    {
      id: "contact",
      title: t("contactCard"),
      image: "/images/contact.png",
      fallback: "/placeholder.svg?height=300&width=200&text=Contact",
      path: "/contact-client",
    },
    {
      id: "facebook-instagram",
      type: "social",
      title: t("facebookInstagram"),
      facebookUrl: "https://www.facebook.com/ibisTunis",
      instagramUrl: "https://www.instagram.com/ibistunis/",
    },
    {
      id: "ecogeste",
      title: t("toSaveEnvironment"),
      image: "/images/ecogeste.png",
      backgroundImage: ECOGESTE_CARD_BG_IMAGE_URL,
      backgroundImageOpacity: 1,
      fallback: "/placeholder.svg?height=300&width=200&text=Ecogeste",
      path: "/policy-client",
      fullWidth: true,
    },
  ]

  return (
    <div className={`ibis-v2-app ${currentLanguage === "ar" ? "rtl" : "ltr"}`}>
      <header className="ibis-v2-home-top" role="banner">
        <div className="ibis-v2-home-top-branding" aria-hidden="true">
          <a href="/home" className="ibis-v2-home-top-logo">
            <img src="/images/logo2.webp" alt="" width={108} height={36} />
          </a>
        </div>
        <div className="ibis-v2-home-top-actions">
          <button
            type="button"
            className="ibis-v2-home-menu-btn"
            onClick={() => setAppMenuOpen(true)}
            aria-expanded={appMenuOpen}
            aria-controls="ibis-v2-appmenu-panel"
            aria-label={t("menu")}
          >
            <span className="ibis-v2-appbar-menu-bars" aria-hidden>
              <span />
              <span />
              <span />
            </span>
          </button>
        </div>
      </header>

      <section className="ibis-v2-hero-brand" aria-label="ibis">
        <div className="ibis-v2-hero-brand-mark">
          <img
            src="/images/home-logo.png"
            alt="ibis"
            className="ibis-v2-hero-brand-logo-img"
            width={200}
            height={200}
            decoding="async"
          />
        </div>
        <p className="ibis-v2-hero-brand-tagline">{t("vibrezAvecNous")}</p>
      </section>

      <main className="ibis-v2-main">
        <div className="ibis-v2-main-content">
          <div className="ibis-v2-feature-cards-container">
            <div className="ibis-v2-feature-cards">
              {getAllFeatureCards().map((card) => {
                const isSocial = card.type === "social"
                const fullWidth = card.fullWidth
                return (
                  <div
                    key={card.id}
                    className={`ibis-v2-feature-card${isSocial ? " ibis-v2-feature-card--social" : ""}${fullWidth ? " ibis-v2-feature-card--fullwidth" : ""}`}
                    onClick={() => {
                      if (isSocial) return
                      if (card.url) {
                        window.open(card.url, "_blank")
                      } else if (card.path) {
                        window.location.href = card.path
                      }
                    }}
                    style={{ cursor: isSocial ? "default" : "pointer" }}
                  >
                    {isSocial ? (
                      <div
                        className="ibis-v2-feature-social-card"
                        onClick={(e) => e.stopPropagation()}
                        role="group"
                        aria-label={card.title}
                      >
                        <div className="ibis-v2-feature-social-card-icons">
                          <a
                            href={card.facebookUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="ibis-v2-feature-social-card-icon"
                            aria-label="Facebook"
                          >
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                              <path
                                d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </a>
                          <a
                            href={card.instagramUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="ibis-v2-feature-social-card-icon"
                            aria-label="Instagram"
                          >
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                              <rect x="2" y="2" width="20" height="20" rx="5" ry="5" stroke="currentColor" strokeWidth="2" />
                              <path
                                d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
                                stroke="currentColor"
                                strokeWidth="2"
                              />
                              <line
                                x1="17.5"
                                y1="6.5"
                                x2="17.51"
                                y2="6.5"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                            </svg>
                          </a>
                        </div>
                        <div className="ibis-v2-feature-social-card-footer">{t("gardonsContact")}</div>
                      </div>
                    ) : (
                      <div
                        className={`ibis-v2-feature-card-media${card.backgroundImage ? " ibis-v2-feature-card-media--remote-bg" : ""}${card.titleVariant === "dark" ? " ibis-v2-feature-card-media--dark-caption" : ""}`}
                      >
                        {card.backgroundImage ? (
                          <div
                            className="ibis-v2-feature-card-media-bg"
                            style={{
                              opacity: card.backgroundImageOpacity ?? 0.66,
                              backgroundImage: `url("${card.backgroundImage}")`,
                            }}
                            aria-hidden
                          />
                        ) : (
                          <img
                            loading="lazy"
                            decoding="async"
                            src={card.image || card.fallback}
                            alt=""
                            onError={(e) => {
                              e.currentTarget.src =
                                card.fallback ||
                                `/placeholder.svg?height=300&width=200&text=${encodeURIComponent(card.title)}`
                            }}
                          />
                        )}
                        <div
                          className={`ibis-v2-feature-title${card.titleVariant === "dark" ? " ibis-v2-feature-title--dark" : ""}`}
                        >
                          {card.title}
                        </div>
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
          </div>

          <a
            href=" https://bit.ly/3yc3qnj"
            target="_blank"
            rel="noopener noreferrer"
            className="ibis-v2-membership-banner"
            style={{
              opacity: 1,
              backgroundImage: `url("${MEMBERSHIP_BANNER_IMAGE_URL}")`,
            }}
            aria-label={t("membership")}
          >
            <span className="ibis-v2-membership-banner-bar">{t("membership")}</span>
          </a>

          <div className="copyright">
            <p>
              © {new Date().getFullYear()} IBIS Tunis. {t("allRightsReserved")}.
              <br />
              {t("createdBy")}{" "}
              <a href="https://www.itbafa.com" target="_blank" rel="noopener noreferrer">
                <img
                  src="/images/itbafa_logo_dark.png"
                  alt="ITBAFA Logo"
                  style={{ height: "20px", verticalAlign: "middle", marginLeft: "5px" }}
                />
              </a>
            </p>
          </div>
          <br></br>
        </div>
      </main>

      <div
        className={`ibis-v2-appmenu-overlay ${appMenuOpen ? "ibis-v2-appmenu-overlay--open" : ""}`}
        aria-hidden={!appMenuOpen}
      >
        <div className="ibis-v2-appmenu-backdrop" onClick={() => setAppMenuOpen(false)} role="presentation" />
        <nav id="ibis-v2-appmenu-panel" className="ibis-v2-appmenu-panel">
          <button
            type="button"
            className="ibis-v2-appmenu-close"
            onClick={() => setAppMenuOpen(false)}
            aria-label={t("close")}
          >
            ×
          </button>
          <a href="/" className="ibis-v2-appmenu-link" onClick={() => setAppMenuOpen(false)}>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
              <path
                d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <polyline
                points="9 22 9 12 15 12 15 22"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>{t("home")}</span>
          </a>
          <a href="/RestaurantsMenus-client" className="ibis-v2-appmenu-link" onClick={() => setAppMenuOpen(false)}>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
              <path
                d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2M7 2v20M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>{t("restaurants")}</span>
          </a>
          <a href="/boissons-client" className="ibis-v2-appmenu-link" onClick={() => setAppMenuOpen(false)}>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
              <path
                d="M5 12V7a1 1 0 0 1 1-1h4l2-3h2l2 3h4a1 1 0 0 1 1 1v5M5 12l1.5 6h11L19 12M5 12h14"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>{t("bar")}</span>
          </a>
          <a
            href="#"
            className="ibis-v2-appmenu-link"
            onClick={(e) => {
              e.preventDefault()
              setAppMenuOpen(false)
              window.open(
                "https://www.google.com/travel/search?q=ibis%20tunis%20google%20avis&g2lb=4965990%2C72471280%2C72560029%2C72573224%2C72647020%2C72686036%2C72799179%2C72803964%2C72882230%2C72958624%2C73059275%2C73064764%2C73249147%2C121529349&hl=fr-TN&gl=tn&ssta=1&ts=CAEaRwopEicyJTB4MTJmZDM0NjQ5Y2Y1ZDMwYjoweDQ0NWQxYWIyZWVjYzkwN2YSGhIUCgcI6g8QBBgTEgcI6g8QBBgUGAEyAhAA&qs=CAEyE0Nnb0lfNkN5OXE3V3hxNUVFQUU4AkIJCX-QzO6yGl1EQgkJf5DM7rIaXUQ&ap=ugEHcmV2aWV3cw&ictx=111&ved=0CAAQ5JsGahcKEwjQ27b0oYiTAxUAAAAAHQAAAAAQBQ",
                "_blank",
              )
            }}
          >
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
              <path
                d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>{t("feedback")}</span>
          </a>

          <div className="ibis-v2-appmenu-lang-section">
            <p className="ibis-v2-appmenu-lang-label">{t("language")}</p>
            <div className="ibis-v2-appmenu-lang-list" role="listbox" aria-label={t("language")}>
              {languages.map((lang) => (
                <button
                  key={lang.code}
                  type="button"
                  className={`ibis-v2-appmenu-lang-option ${currentLanguage === lang.code ? "ibis-v2-appmenu-lang-option--active" : ""}`}
                  role="option"
                  aria-selected={currentLanguage === lang.code}
                  onClick={() => {
                    changeLanguage(lang.code)
                    setAppMenuOpen(false)
                  }}
                >
                  <img src={lang.flag || "/placeholder.svg"} alt="" className="flag-small" />
                  <span>{lang.name}</span>
                </button>
              ))}
            </div>
          </div>
        </nav>
      </div>

      {showPopup && activeOffer && (
        <div className="ibis-v2-popup-overlay active" onClick={() => setShowPopup(false)}>
          <div className={`ibis-popup-modern${currentLanguage === "ar" ? " ibis-popup-rtl" : ""}`} onClick={e => e.stopPropagation()}>
            {/* Close */}
            <button className="ibis-popup-close-btn" onClick={() => setShowPopup(false)}>×</button>

            {/* Badge */}
            <div className="ibis-popup-badge">
              🎯 {t("specialOffers")}
            </div>

            {/* Media — image as cover, video as autoplay below */}
            {(activeOffer.image || activeOffer.video) && (
              <div className="ibis-popup-media">
                {activeOffer.video ? (
                  <video
                    key={getMediaUrl(activeOffer.video)}
                    src={getMediaUrl(activeOffer.video)}
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="ibis-popup-video"
                  />
                ) : (
                  <img
                    src={getMediaUrl(activeOffer.image)}
                    alt={activeOffer.title}
                    className="ibis-popup-img"
                  />
                )}
                <div className="ibis-popup-media-overlay" />
              </div>
            )}
            {/* If both exist show image thumbnail strip below video */}
            {activeOffer.video && activeOffer.image && (
              <div className="ibis-popup-thumb-strip">
                <img src={getMediaUrl(activeOffer.image)} alt="" className="ibis-popup-thumb" />
              </div>
            )}

            {/* Content */}
            <div className="ibis-popup-body">
              {/* Discount pill */}
              <div className="ibis-popup-discount">
                −{activeOffer.discountPercentage}%
              </div>

              <h2 className="ibis-popup-title">
                {activeOffer.translations?.[currentLanguage]?.title || activeOffer.title}
              </h2>

              {activeOffer.translations?.[currentLanguage]?.description || activeOffer.description ? (
                <p className="ibis-popup-desc">
                  {activeOffer.translations?.[currentLanguage]?.description || activeOffer.description}
                </p>
              ) : null}

              <div className="ibis-popup-validity">
                📅 {new Date(activeOffer.startDate).toLocaleDateString(currentLanguage === "ar" ? "ar-TN" : currentLanguage === "en" ? "en-US" : "fr-FR")}
                {" → "}
                {new Date(activeOffer.endDate).toLocaleDateString(currentLanguage === "ar" ? "ar-TN" : currentLanguage === "en" ? "en-US" : "fr-FR")}
              </div>

              <a href="/offres-client" className="ibis-popup-cta">
                {t("discoverOffers")} →
              </a>
            </div>
          </div>
        </div>
      )}

    </div>
  )
}

export default HomeClient
